import React, { useEffect, useState } from "react";
import SideList from "../../../UI-component/SideList";
import ErrorAlert from "../../../UI-component/ErrorAlert";
import SummaryCard from "../../../UI-component/summary/SummaryCard";
import FormBoxField from "../../../UI-component/ui-el/FormBoxField";
import PopupTextField from "../../../UI-component/ui-el/PopupTextField";
import { PaymentApi } from "../../../Apis/PaymentApi";
import Loader from "../../../UI-component/Loader";
import NextBtnForm from "../../../UI-component/NexBtnForm";
import { useDispatch, useSelector } from "react-redux";
import stepSlice from "../../../context/StepsContext";
import SuccessfullPopup from "../../../UI-component/SuccessfullPopup";
import { uniqueIdBuilder } from "../../../util/Dynamics";
import PopupSelectField from "../../../UI-component/ui-el/PopupSelectField";
import { useFee } from "./fee";

function Specific(props) {
    const {data, values, error: errorHook, loading: loadingHook, update, save, savePrefs, isValidStep} = useFee(props.save, props?.info?.data || {});

    const onNext = () => {
      savePrefs();
      props.next();
    }
    const dispatcher = useDispatch();
    const ctx = useSelector(state => state.stepSlice.data.avviso);
    const ctxPayment = useSelector(state => state.stepSlice.data.pagamento);


    const [show, setShow] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [code, setCode] = useState(ctx ?? "");
    const [securityCode, setSecutiryCode] = useState("")
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [blockErr, setBlockErr] = useState(true);
    const [payments, setPayments] = useState([]);
    const [payment, setPayment] = useState(ctxPayment);

    const onChange = (e) => {
        if (e.target.id.includes("sicurezza")) {
            setSecutiryCode(e.target.value);
            return;
        }

        // setCode(e.target.value);

        update({
            id: "code",
            data: e.target.value
        })
    }

    const getInvoiceInformation = async (cd = false) => {

        // console.log("code", code, cd);
        let invoiceData = {}
        try {
            setLoading(true);
            const res = await PaymentApi.getInvoiceInfoById(!cd ? data?.code : cd);

            if (!res?.success) {
                setError(true);
                setLoading(false);
                // setInvoiceData({});
                setShow(false);
                setBlockErr(true);
                return;
            }

            invoiceData = res.data.invoice_data
            // setInvoiceData(res.data.invoice_data);
            setShow(true);
            setLoading(false);
            setError(false);
            setBlockErr(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
            setShow(false);
            setError({
                code: false,
                securityCode: false
            });
            setBlockErr(true);
        }

        return invoiceData;
    }

    // const onNext = () => {
    //     dispatcher(stepSlice.actions.dynamicSave({ id: "code", data: code }));
    //     dispatcher(stepSlice.actions.dynamicSave({ id: "fattura", data: invoiceData }));
    //     dispatcher(stepSlice.actions.dynamicSave({ id: "pagamento", data: payment }));

    //     props.next();
    // }

    const onError = () => {
        const err = {
            code: false,
        }
        if (code === "")
            err.code = true;

        setError(err);
    }

    const paymentListBuilder = async () => {

        const pays = await PaymentApi.getPayments();

        if (!pays.success) {
            return [];
        }

        const paymentList = [];

        if (pays?.data.length > 0) {
            pays?.data.map((itm, idx) => {
                if (itm.pay)
                    paymentList.push(itm);
            })
        }

        setPayments(paymentList);
    }

    const onChangePayment = async (e, codeToSearch) => {
        // console.log("code", e.target.options[e.target.selectedIndex].text);
        let iuv = codeToSearch;

        if(!codeToSearch){
            const paymentFound = payments.filter(itm => {
                return itm.iuv === e.target.options[e.target.selectedIndex].text;
            })
            iuv = paymentFound[0].iuv;
        }

        if (iuv) {
            const invoiceData = await getInvoiceInformation(iuv)
            const pay = invoiceData;

            update([
                {
                    id: "code",
                    data: pay.iuv
                },
                {
                    id: "pagamento",
                    data: {
                        ...data?.pagamento,
                        fattura: pay.paymentCode,
                        data_emissione: pay?.date,
                        metodo: pay?.paymentMethod || "Non trovato",
                        importo: pay.amount || "Non trovato",
                        iuv: pay.iuv || "Non trovato",
                        link: pay.link
                    }
                },
                {
                    id: "fatture",
                    data: invoiceData
                }
            ])

        }
    }

    useEffect(() => {
        if (data?.code !== "")
            getInvoiceInformation();

        paymentListBuilder();
    }, []);

    return (
        <div className="row">
            <SideList
                infoList={[
                    { element: "Codice avviso (IUV)", id: "#report-author" },
                ]} />

            <div className="col-12 col-lg-8 offset-lg-1">
                <div className="steppers-content" aria-live="polite">
                    <div className="it-page-sections-container">

                        <ErrorAlert errors={[{ name: "Codice avviso (IUV)", id: "#isee-info" }]} err={blockErr} />

                        {/* <SummaryCard
                            type="Avvisi di pagamento*"
                            description={"Scegli il pagamento"}>
                            {

                                <PopupSelectField
                                    defaultValue={payment?.iuv}
                                    onChange={onChangePayment}
                                    id={"code_id"}
                                    fieldTitle={"Codice avviso IUV"}
                                    options={payments.map(itm => itm.iuv)}
                                    description="Seleziona il codice di riferimento"
                                    key={uniqueIdBuilder()} />
                            }
                        </SummaryCard> */}

                        <br></br>
                        <SummaryCard
                            type="Avviso di pagamento*"
                            description={"Seleziona o inserisci il codice avviso"}>

                            <SummaryCard
                                type=""
                                description={""}>
                                {

                                    <PopupSelectField
                                        defaultValue={data?.pagamento?.iuv}
                                        onChange={onChangePayment}
                                        id={"code_id"}
                                        fieldTitle={"Codice avviso (IUV) esistente"}
                                        options={payments.map(itm => itm.iuv)}
                                        description="Seleziona un codice avviso esistente"
                                        key={uniqueIdBuilder()} />
                                }
                            </SummaryCard>
                            <PopupTextField
                                defaultValue={data?.code || data?.pagamento?.iuv || ""}
                                fieldType="text"
                                id="nome"
                                fieldTitle="Codice avviso (IUV)*"
                                description="Inserisci il codice avviso"
                                max="18"
                                straightErr={errorHook?.code && !data?.pagamento?.iuv}
                                onChange={onChange}
                            />
                            <button
                                className="internal-btn"
                                onClick={() => { onChangePayment(null, data?.code) }}>
                                Ricerca fattura</button>
                        </SummaryCard>
                        {
                            data?.fatture?.iuv &&
                            <>
                                <SummaryCard type="Fattura">
                                    <FormBoxField title="Codice IUV" value={data?.pagamento?.iuv} />
                                    <FormBoxField title="Data emissione" value={data?.fatture?.data_emissione} />
                                    <FormBoxField title="Data scadenza" value={data?.fatture?.data_scadenza} />
                                    <FormBoxField title="Ente" value={data?.fatture?.ente} />
                                    <FormBoxField title="Codice Fiscale ente" value={data?.fatture?.codice_fiscale_ente} />
                                    <FormBoxField title="Intestatario" value={data?.fatture?.intestatario} />
                                    <FormBoxField title="Codice Fiscale Intestatario" value={data?.fatture?.codice_fiscale_intestatario} />
                                    <FormBoxField title="Importo dovuto" value={data?.fatture?.importo_dovuto} />
                                    <FormBoxField title="Importo già pagato" value={data?.fatture?.importo_gia_pagato} />
                                </SummaryCard>
                            </>
                        }
                    </div>
                </div>
                {/* <div style={{ transform: "translateY(10%)" }}>
                </div> */}
                <Loader loading={loading || loadingHook} fixedPosition/>

                <NextBtnForm
                    next={onNext}
                    back={props.back}
                    noSave={false}
                    saveRequest={save}
                    disabled={!isValidStep("specific")} />
                {
                    props.saved &&
                    <SuccessfullPopup />
                }

                {
                    props.fail &&
                    <SuccessfullPopup isError={true} />
                }
            </div>
        </div>
    )
}

export default Specific;